//custom.js
document.addEventListener('DOMContentLoaded', function() {
  // メニュー1
  const menuButton1 = document.getElementById('menusp-01');
  const menuContent1 = document.getElementById('menusp-01-content');
  
  // メニュー2
  const menuButton2 = document.getElementById('menusp-02');
  const menuContent2 = document.getElementById('menusp-02-content');
  
  // メニュー1のクリックイベント
  menuButton1.addEventListener('click', function(e) {
    e.preventDefault();
    
    const isExpanded = this.getAttribute('aria-expanded') === 'true';
    const body = document.body;
    
    // 他のメニューを閉じる
    menuButton2.setAttribute('aria-expanded', 'false');
    menuContent2.classList.remove('is-open');
    
    // このメニューの状態を更新
    this.setAttribute('aria-expanded', !isExpanded);
    
    if (!isExpanded) {
      menuContent1.classList.add('is-open');
      body.classList.add('no-scroll');
    } else {
      menuContent1.classList.remove('is-open');
      body.classList.remove('no-scroll'); // メニューを閉じる時にno-scrollを削除
    }
  });
  
  // メニュー2のクリックイベント
  menuButton2.addEventListener('click', function(e) {
    e.preventDefault();
    
    const isExpanded = this.getAttribute('aria-expanded') === 'true';
    const body = document.body;
    
    // 他のメニューを閉じる
    menuButton1.setAttribute('aria-expanded', 'false');
    menuContent1.classList.remove('is-open');
    
    // このメニューの状態を更新
    this.setAttribute('aria-expanded', !isExpanded);
    
    if (!isExpanded) {
      menuContent2.classList.add('is-open');
      body.classList.add('no-scroll');
    } else {
      menuContent2.classList.remove('is-open');
      body.classList.remove('no-scroll'); // メニューを閉じる時にno-scrollを削除
    }
  });

  // アコーディオンメニューの処理
  const accordions = document.querySelectorAll('.menu-accordion');
  
  accordions.forEach(accordion => {
    const title = accordion.querySelector('.menu-accordion__title');
    const content = accordion.querySelector('.menu-accordion__content');
    
    title.addEventListener('click', function(e) {
      e.preventDefault();
      
      const isExpanded = accordion.hasAttribute('open');
      
      if (!isExpanded) {
        // 開く処理
        accordion.setAttribute('open', '');
        // 以前閉じた際に付与した「is-hidden」クラスがあれば削除
        content.classList.remove('is-hidden');
        // 次のフレームで is-open を付与して開くアニメーション開始
        requestAnimationFrame(() => {
          content.classList.add('is-open');
        });
      } else {
        // 閉じる処理
        content.classList.remove('is-open');
        // max-height の transition 終了を待ってから、.is-hidden を付与し open 属性を削除する
        content.addEventListener('transitionend', function handler(e) {
          if (e.propertyName === 'max-height') {
            content.classList.add('is-hidden');
            accordion.removeAttribute('open');
            content.removeEventListener('transitionend', handler);
          }
        });
      }
    });
  });
});

// mainにヘッダーの高さのマージン付与
document.addEventListener('DOMContentLoaded', function() {
  function adjustMainMargin() {
    const header = document.querySelector('.header-wrapper');
    const main = document.querySelector('main');

    if (header && main) {
      const headerHeight = header.getBoundingClientRect().height;

      if (window.innerWidth <= 989) {
        main.style.marginTop = `${headerHeight}px`;
      } else {
        main.style.marginTop = '0';
      }
    }
  }

  adjustMainMargin();

  window.addEventListener('resize', adjustMainMargin);
});